import { FC, useMemo, useCallback } from 'react';
import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';
import { Option } from 'utils/customTypes';
import { PROJECT_PRIVACY } from 'utils/constants/projectsList';
import { ProjectPrivacy } from 'utils/types/projectsList';

interface ProjectPrivacyFilterProps {
  onSelect: (selected: ProjectPrivacy[]) => void;
  selected?: ProjectPrivacy[];
}

const ProjectPrivacyFilter: FC<ProjectPrivacyFilterProps> = ({
  selected,
  onSelect,
}) => {
  const privacyOptions = useMemo(() => {
    return Object.keys(PROJECT_PRIVACY).map((key) => ({
      value: PROJECT_PRIVACY[key as keyof typeof PROJECT_PRIVACY],
      label: intl.get(`PROJECT_DETAIL.PRIVACY_OPTIONS.${key}`),
    }));
  }, []);

  const selectedOptions = useMemo(() => {
    return privacyOptions.filter((option) =>
      selected?.includes(option.value as ProjectPrivacy)
    );
  }, [privacyOptions, selected]);

  const handleOnChange = useCallback(
    (selectedOptions: Option[]) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      onSelect(selectedValues as ProjectPrivacy[]);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.PRIVACY')}>
      <Dropdown
        options={privacyOptions}
        values={selectedOptions}
        onChange={handleOnChange}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-privacy-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectPrivacyFilter;
